<template lang="pug">
section.section.main-content
	.o-container
		.main-content__inner
			header.headline
				h1.headline__title Cotización \#{{quote.id}}
			.button-status
				.button.button--green Cotizado
		.quote-reject
			.quote-reject__left
				p.quote-reject__description.
					Indicados el motivo del rechazo de la cotización.
				form
					ul.custom-input.check_box
						li.custom-input__item
							input#check-1(type="checkbox" name="selector")
							label(for="check-1", class="custom-input__label") Tasa muy alta
							.check
								.inside
						li.custom-input__item
							input#check-2(type="checkbox" name="selector")
							label(for="check-2", class="custom-input__label") Prefiero condiciones de la competencia
							.check
								.inside
						li.custom-input__item
							input#check-3(type="checkbox" name="selector")
							label(for="check-3", class="custom-input__label") Se demoraron mucho en cotizar
							.check
								.inside
						li.custom-input__item
							input#check-4(type="checkbox" name="selector")
							label(for="check-4", class="custom-input__label") Cotización referencial
							.check
								.inside
						li.custom-input__item
							input#check-5(type="checkbox" name="selector")
							label(for="check-5", class="custom-input__label") No obtuve carta de nombramiento
							.check
								.inside
			.quote-reject__right
				.c-historial
					h3.c-historial__title Historial
					.c-historial__list
						.c-historial__item
							.c-historial__date
								span 20, Febrero 2019
							.c-historial__icon
								span.circle.circle--green
							.c-historial__description
								span Creación de Cotización
		.content-buttons
			a(href="/dashboard" class="button button--black") DESISTIR
			a(href="/dashboard" class="button button--default") CANCELAR

</template>
<script>
import axios from 'axios';
import SiteConfig from '../services/positiva';

export default {
	name: 'QuoteCancelar',
	data () {
		return {
			errs: [],
			dataTable:[],
			quote:{},
			storedData:{}
		}
	},
	mounted () {
		this.storedData = JSON.parse( SiteConfig.GetSession() );

		axios.get(SiteConfig.BASE_URL + '/api/quotation/' + this.$route.params.id + '/detail',
			{
	            headers: {
	            	'Authorization': 'Token ' + this.storedData.token,
	            	'Content-Type': 'application/json'
	        	}
  			}
  		)
		.then((response) => {
			if (response.status == 200) {
				this.quote = response.data
			}
		}).catch((error) => {
			
		});
	},
	methods: {
		getStateClass(state) {
			if (state == 1)
				return 'button--orange'
			else if (state == 2 || state == 4)
				return 'button--green'
			else if (state == 3)
				return 'button--brown'
			else if (state == 5)
				return 'button--gray'
		}
	}
}
</script>